import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DefaultLayout from "layout/DefaultLayout";
import NotFound from "pages/Authorization/NotFound";
import Home from "pages/Static/Home";
import AccessDenied from "pages/Authorization/AccessDenied";
import { NOTFOUND, DENIED, FORBIDDEN, } from "_constants/PageRoutes";
import Forbidden from "../pages/Authorization/Forbidden";

/* Almost same with AuthSitePublicRoute. Difference is for accessing Home:
 * <Route exact path="/">
 *   <Home />
 * </Route>
 * While AuthSitePublicRoute needs:
 * <Route exact path={HOME}>
 *  <Home />
 * </Route>
 * <Route exact path="/">
 *  <Redirect to={HOME} />
 * </Route>
 */
const PublicSiteRoute = (props) => {
    return (
        <DefaultLayout>
            <Switch>
                {props.publicRoutes && props.publicRoutes.map(
                    (item, key) =>
                        <Route
                            key={key}
                            exact={item.exact ?? true}
                            path={item.redirect}
                            component={item.component}
                        />
                )}
                <Route path={DENIED}>
                    <AccessDenied />
                </Route>
                <Route path={FORBIDDEN}>
                    <Forbidden />
                </Route>
                <Route path={NOTFOUND}>
                    <NotFound />
                </Route>
                <Route exact path="/">
                    <Home />
                </Route>
                <Redirect to={NOTFOUND} />
            </Switch>
        </DefaultLayout>
    );
};

export default PublicSiteRoute;
